import React from "react";
import { Link } from "react-router-dom";

/**
 * Link-styled button.
 * variant: primary | secondary | light | ghost   size: md | sm
 * Pass `href` for external links, `onClick` for real buttons.
 */
export default function Button({
  to = "/contact",
  href,
  onClick,
  children,
  variant = "primary",
  size = "md",
  arrow = true,
  className = "",
  ...rest
}) {
  const cls = `btn btn-${variant}${size === "sm" ? " btn-sm" : ""} ${className}`.trim();
  const content = (
    <>
      {children}
      {arrow && <span className="arrow" aria-hidden="true">→</span>}
    </>
  );

  if (onClick) return <button type="button" className={cls} onClick={onClick} {...rest}>{content}</button>;
  if (href) return <a className={cls} href={href} target="_blank" rel="noopener noreferrer" {...rest}>{content}</a>;
  return <Link className={cls} to={to} {...rest}>{content}</Link>;
}
